module.exports = new __parcel__URL__("81895_sq.4ace7755.jpg").toString();